export default "__VITE_ASSET__Drre$UgH__"